import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DmiComponent } from './dmi.component';
import { RouterModule, Routes } from '@angular/router';
import { UiElementsModule } from 'src/app/common-modules/ui-elements.module';
import { MappingModule } from 'src/app/common-modules/mapping.module';
import { DmiCommonModule } from 'src/app/common-modules/dmi-common.module';
import { FormsModule } from '@angular/forms';
import { MapsComponent } from '../dmi-pages/maps/maps.component';
import { DMIGuard } from 'src/app/auth/dmi.guard';
import { ArcgisConfigComponent } from '../dmi-pages/data/arcgis/arcgis-config/arcgis-config.component';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { MenuTesterComponent } from 'src/app/components/dmi/menu-tester/menu-tester.component';
import { SandboxedGuard } from 'src/app/auth/sandboxed.guard';

const dmiRoutes: Routes = [
  {
    path: 'dmi',
    component: DmiComponent,
    children: [
      {
        path: 'data/arcgis/config',
        component: ArcgisConfigComponent,
        canActivate: [DMIGuard]
      },
      {
        path: 'testing',
        component: MenuTesterComponent,
        canActivate: [DMIGuard]
      },
      {
        path: 'maps',
        component: MapsComponent,
        canActivate: [DMIGuard]
      },
      {
        path: 'viewer',
        loadChildren: () => import('../../mapps/viewer/viewer.module').then(m => m.ViewerModule),
        canActivate: [DMIGuard]
      },
      {
        path: 'sl-viewer',
        loadChildren: () => import('../../mapps/sl-viewer/sl-viewer.module').then(m => m.SLViewerModule),
        canActivate: [DMIGuard]
      }
    ]
  },


];

@NgModule({
  declarations: [DmiComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(dmiRoutes),
    UiElementsModule,
    MappingModule,
    FormsModule,
    DmiCommonModule
],
  exports: [
  ]

})
export class DmiModule { }
